import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

const TO_ARTICLE_DISPLAY_CARD_BUTTON_ICON = "i-vignette";
const TO_ARTICLE_HYPERLINK_BUTTON_ICON = "i-link";

export class articlePickerView_template extends vnTemplate {
  protected parent: any;

  protected getTemplateHtml(): string {
    return /* html */ `
        <div class="w-picker-form form-view" id="article-picker-view" data-bind="css: { 'is-visible': isShown }">

            <div class="picker-form">
                <div class="form-header w-justify">
                    <div class="w-left">
                    </div>
                    <div class="w-center">
                        <div class="section-title">
                            <h3 class="section-title" data-bind="text: formTitle"></h3>
                        </div>
                    </div>
                    <div class="w-right">
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                </div>

                <div class="form-body" >

                    <div class="body-header w-justify">
                        <div class="w-left">
                            <button type="button" class="btn icon" data-bind="text: hyperlinkButtonLabel, event: { click : onClickToggleHyperlink }, class: hyperlinkButtonIcon"></button>
                        </div>
                        <div class="w-right">
                            <button type="button" class="btn icon i-preview" data-bind="visible: !isHyperlink(), event: { click : onClickInsertContentPreview }">Content Preview</button>
                            <button type="button" class="btn icon i-ins" data-bind="event: { click : onClickInsert }">Insert</button>
                        </div>
                    </div>

                    <div class="article-header">
                        <div class="article-header-left" data-bind="visible: !isHyperlink()">

                            <div class="form-group">
                                <div class="w-img" data-bind="visible: image() != null">
                                    <button class="btn only-icon icon i-overwrite" type="button" title="overwrite image" data-bind="css: { 'is-overwrite' : imageOverride() != null }, event: { click: onClickImageOverride }"><span class="hidden-text">overwrite</span></button>
                                    <img data-bind="attr: {src: (image() != null ? image().url : '') }, , css: { 'is-override' : imageOverride() != null }">
                                    <div class="w-img" data-bind="visible: imageOverride() != null ">
                                        <button class="btn icon i-overwrite" type="button" title="override image" data-bind="event: { click: onClickEditImageOverride }"><span>override</span></button>
                                        <button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteImageOverride }"><span class="hidden-text">cancel override</span></button>
                                        <img data-bind="attr: { src :  (imageOverride() != null ? imageOverride().url : '') } ">
                                    </div>
                                </div>
                            </div>
                            <br>

                            <div class="form-group custom-badge">
                                <label for="" class="form-label icon i-image" style="margin-bottom: 0;">Image Size</label>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="articlePicker-img-small" name="article-picker-view-type-radio-group" value="small" data-bind="checked: viewType">
                                    <label for="articlePicker-img-small">Small</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="articlePicker-img-hide" name="article-picker-view-type-radio-group" value="hide" data-bind="checked: viewType">
                                    <label for="articlePicker-img-hide">Hide Image</label>
                                </div>
                            </div>


                            <div class="form-group" style="margin-top: 2rem">
                              <label for="" class="form-label">Label</label>
                                <div><input type="text" class="input-text" data-bind="value: label"></div>
                            </div>

                        </div>

                        <div class="article-header-right">
                            <div class="article-header-bottom-row" data-bind="css: { 'is-overwrite' : titleOverride() != null }">

                                <div class="form-group">
                                    <label for="" class="form-label">Title</label>
                                    <span class="form-read" data-bind="text: title() != null ? title : 'None'"></span>
                                </div>

                                <div class="form-group" >
                                    <input type="checkbox" data-bind="event: { click: onClickTitleOverride }, checked: titleOverride() != null" id="articlePicker-title-override">
                                    <label for="articlePicker-title-override" class="icon i-check">Override</label>
                                    <div><textarea data-bind="value: titleOverride"></textarea></div>
                                </div>
                            </div>

                            <div class="article-header-bottom-row" data-bind="visible: !isHyperlink(), css: { 'is-overwrite' : excerptOverride() != null }">

                                <div class="form-group">
                                    <label for="" class="form-label">Excerpt</label>
                                    <span class="form-read" data-bind="text: excerpt() != null ? excerpt : 'None'"></span>
                                </div>

                                <div class="form-group">
                                    <input type="checkbox" data-bind="event: { click: onClickExcerptOverride }, checked: excerptOverride() != null" id="articlePicker-excerpt-override">
                                    <label for="articlePicker-excerpt-override" class="icon i-check">Override</label>
                                    <div><textarea data-bind="value: excerptOverride"></textarea></div>
                                </div>
                            </div>

                            <div class="article-header" data-bind="visible: isHyperlink()">

                              <div class = "form-group">
                                <div class="form-row">
                                  <label for="" class="form-label">permalink</label>
                                  <button type="button" class="btn icon i-link" data-bind="visible: permalink() != null, event: { click: onClickViewOnSite }">Open Article</button>
                                </div>
                                <span class="form-read" data-bind="text: permalink()">

                                </span>
                              </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
  }

  protected getTemplateName(): string {
    return "articlePickerView-template";
  }

  protected buildViewModel(): any {
    //create observable array refresh function
    // define the viewmodel data/ functions
    let self = this;
    let viewModel = {
      isShown: ko.observable(false),
      idArticle: ko.observable(null),
      image: ko.observable(null),
      imageOverride: ko.observable(null),
      viewType: ko.observable('small'),
      title: ko.observable(null),
      titleOverride: ko.observable(null),
      excerpt: ko.observable(null),
      excerptOverride: ko.observable(null),
      label: ko.observable("Related"),
      articleElement: ko.observable(null),
      permalink: ko.observable(null),
      isHyperlinkModeEnabled: ko.observable(false),
      isHyperlinkValue: ko.observable(false),
      hyperlinkType: ko.observable('internal'),
      isPartOfGroup: ko.observable(false),
      groupExists: ko.observable(false),
      onClickCancel: function (data, event) { self.onClickCancel(); },
      onClickInsert: function (data, event) { self.onClickInsert(data); },
      onClickInsertContentPreview: function (data, event) { self.onClickInsertContentPreview(data); },
      onClickTitleOverride: function (data, event) { return self.onClickTitleOverride(); },
      onClickExcerptOverride: function (data, event) { return self.onClickExcerptOverride(); },
      onClickImageOverride: function (data, event) { self.onClickImageOverride(); },
      onClickDeleteImageOverride: function(data, event){ self.onClickDeleteImageOverride(); },
      onClickEditImageOverride: function(data, event){ self.onClickEditImageOverride(); },
      onClickToggleHyperlink: function (data, event) { self.onClickToggleHyperlink(); },
      onClickViewOnSite: function (data, event) { self.onClickViewOnSite(); },
      onClickAddToGroup: function (data, event) { self.onClickAddToGroup(); },
      onClickSaveToGroup: function (data, event) { self.onClickSaveToGroup(); },
      isHyperlink: ko.pureComputed(() => {
        return viewModel.isHyperlinkModeEnabled()
          && viewModel.isHyperlinkValue()
      }),
      hyperlinkButtonIcon: ko.pureComputed(() => {
        return viewModel.isHyperlink() ? TO_ARTICLE_DISPLAY_CARD_BUTTON_ICON : TO_ARTICLE_HYPERLINK_BUTTON_ICON;
      }),
      formTitle: ko.pureComputed(() => {
        return viewModel.isHyperlink() ? 'Article Hyperlink' : 'Article Display Card';
      }),
      hyperlinkButtonLabel: ko.pureComputed(() => {
        return viewModel.isHyperlink() ? 'Change to Display Card Style' : 'Change to Hyperlink Style';
      }),
    };

    return viewModel;
  }

  public setParent(parent){
    this.parent = parent;
  }

  public setArticleData(article){

    this.getTemplateViewModel().idArticle(article.id);
    this.getTemplateViewModel().image(article.featuredImage);
    this.getTemplateViewModel().title(article.title);
    this.getTemplateViewModel().excerpt(article.excerpt);
    this.getTemplateViewModel().permalink(article.permalink);

    if (this.parent && this.parent.getTemplateViewModel().selectedArticles().length > 0) {
      this.setGroupExists(true);
    } else {
      this.setGroupExists(false);
    }
    this.setIsPartOfGroup(false);

    this.show();
  }

  public setArticleInsertedItems(insertedItems){
    if(insertedItems != null){
      this.getTemplateViewModel().imageOverride(insertedItems.imageOverride);
      this.getTemplateViewModel().viewType(insertedItems.viewType);
      this.getTemplateViewModel().titleOverride(insertedItems.titleOverride);
      this.getTemplateViewModel().excerptOverride(insertedItems.excerptOverride);
      this.getTemplateViewModel().label(insertedItems.label)
      this.getTemplateViewModel().permalink(insertedItems.permalink);
      this.getTemplateViewModel().isHyperlinkValue(insertedItems.isHyperlink);
  }else{
      this.getTemplateViewModel().imageOverride(null);
      this.getTemplateViewModel().viewType('small');
      this.getTemplateViewModel().titleOverride(null);
      this.getTemplateViewModel().excerptOverride(null);
      this.getTemplateViewModel().label("Related")
      this.getTemplateViewModel().permalink(null);
      this.getTemplateViewModel().isHyperlinkValue(false);
  };
  }


  public getIsHyperlinkModeEnabled(){

    return this.getTemplateViewModel().isHyperlinkModeEnabled();
  }

  public setIsHyperlinkModeEnabled(isHyperlinkModeEnabled){

    this.getTemplateViewModel().isHyperlinkModeEnabled(isHyperlinkModeEnabled);
  }

  public setTitleOverride(titleOverride) {

    this.getTemplateViewModel().titleOverride(titleOverride);
  }


  public show(){

      this.getTemplateViewModel().isShown(true);
  }

  public hide(){

      this.getTemplateViewModel().isShown(false);
  }

  public showLoading(){

    let list = document.getElementById("article-picker-view");
    list.classList.add("loading")
  }

  public hideLoading(){

    let list = document.getElementById("article-picker-view");
    list.classList.remove("loading")
  }

  protected onClickCancel() {
    this.hide();
    this.restPageValues();
    this.parent.fillPage();
  }

  protected onClickInsert(data) {
    let elementToReplace = this.getTemplateViewModel().articleElement();
    if (elementToReplace && !elementToReplace.parentElement) {
      elementToReplace = null;
    }
    if (!elementToReplace && this.parent.getTemplateViewModel().articleGroupElement()) {
      elementToReplace = this.parent.getTemplateViewModel().articleGroupElement();
    }
    let articleObject = this.getArticleObject();
    if (this.getTemplateViewModel().isHyperlink()) {
      this.caller.insertArticleHyperlinkElement(elementToReplace, articleObject);
    } else {
      this.caller.insertArticleDisplayCardElement(elementToReplace, articleObject);
    }
  }

  protected onClickInsertContentPreview(data) {
    let elementToReplace = this.getTemplateViewModel().articleElement();
    if (elementToReplace && !elementToReplace.parentElement) {
      elementToReplace = null;
    }
    if (!elementToReplace && this.parent.getTemplateViewModel().articleGroupElement()) {
      elementToReplace = this.parent.getTemplateViewModel().articleGroupElement();
    }
    let articleObject = this.getArticleObject();
    this.caller.insertArticleContentPreviewElement(elementToReplace, articleObject);
  }

  protected onClickTitleOverride() {
    let titleOverride = this.getTemplateViewModel().titleOverride();
    if (titleOverride != null) {
      this.getTemplateViewModel().titleOverride(null);
    } else {
      this.getTemplateViewModel().titleOverride("");
    }
    return true;
  }

  protected onClickExcerptOverride() {
    let excerptOverride = this.getTemplateViewModel().excerptOverride();
    if (excerptOverride != null) {
      this.getTemplateViewModel().excerptOverride(null);
    } else {
      this.getTemplateViewModel().excerptOverride("");
    }
    return true;
  }

  protected onClickImageOverride(){

    this.caller.showImagePicker("single-select", "articleImageOverride");
  }

  protected onClickDeleteImageOverride(){

      this.getTemplateViewModel().imageOverride(null);
  }

  protected onClickEditImageOverride(){

    let imageOverride = this.getTemplateViewModel().imageOverride();

    if(imageOverride.id == null){
        this.caller.getImage(imageOverride.url);
    }else{
        this.caller.editImage(imageOverride);
    }

    this.caller.showImagePicker("single-select", "articleImageOverrideEdit");
  }

  public setArticleImageOverride(image){

    this.getTemplateViewModel().imageOverride(image);
  }

  protected getArticleObject(){

    let id = this.getTemplateViewModel().idArticle();
    let image = this.getTemplateViewModel().image();
    let imageOverride = this.getTemplateViewModel().imageOverride();
    let viewType = this.getTemplateViewModel().viewType();
    let title = this.getTemplateViewModel().title();
    let titleOverride = this.getTemplateViewModel().titleOverride();
    let excerpt = this.getTemplateViewModel().excerpt();
    let excerptOverride = this.getTemplateViewModel().excerptOverride();
    let label = this.getTemplateViewModel().label();
    let permalink = this.getTemplateViewModel().permalink();
    let hyperlinkType = this.getTemplateViewModel().hyperlinkType();

    return {
        id : id,
        image : image,
        imageOverride : imageOverride,
        viewType: viewType,
        title : title,
        titleOverride : titleOverride,
        excerpt : excerpt,
        excerptOverride : excerptOverride,
        label : label,
        permalink : permalink,
        hyperlinkType : hyperlinkType
    };
  }

  public restPageValues(){

    this.getTemplateViewModel().idArticle(null);
    this.getTemplateViewModel().image(null);
    this.getTemplateViewModel().imageOverride(null);
    this.getTemplateViewModel().viewType('small');
    this.getTemplateViewModel().title(null);
    this.getTemplateViewModel().titleOverride(null);
    this.getTemplateViewModel().excerpt(null);
    this.getTemplateViewModel().excerptOverride(null);
    this.getTemplateViewModel().label("Related");
    //this.getTemplateViewModel().articleElement(null);
    this.getTemplateViewModel().permalink(null);
    this.getTemplateViewModel().isHyperlinkValue(false);
  }

  protected onClickToggleHyperlink() {

    if (this.getTemplateViewModel().isHyperlinkModeEnabled()) {
      this.getTemplateViewModel().isHyperlinkValue(!this.getTemplateViewModel().isHyperlinkValue());
    }
  }

  protected onClickViewOnSite() {

    let brand = this.caller.articlePicker.getBrand();
    let permalink = this.getTemplateViewModel().permalink();
    this.caller.viewArticleOnSite(brand, permalink);
  }

  public quickInsertArticleHyperlink(article) {

    this.getTemplateViewModel().idArticle(article.id);
    this.getTemplateViewModel().image(article.featuredImage);
    this.getTemplateViewModel().title(article.title);
    this.getTemplateViewModel().excerpt(article.excerpt);
    this.getTemplateViewModel().permalink(article.permalink);

    const elementToReplace = this.getTemplateViewModel().articleElement();
    const articleObject = this.getArticleObject();
    this.caller.insertArticleHyperlinkElement(elementToReplace, articleObject);
  }

  public setIsPartOfGroup(isPartOfGroup) {
    this.getTemplateViewModel().isPartOfGroup(isPartOfGroup);
  }

  public setGroupExists(groupExists) {
    this.getTemplateViewModel().groupExists(groupExists);
  }

  protected onClickAddToGroup() {
    let articleObject = this.getArticleObject();
    this.parent.selectArticle(articleObject);
    this.hide();
  }

  protected onClickSaveToGroup() {
    let articleObject = this.getArticleObject();
    let selectedArticles = this.parent.getTemplateViewModel().selectedArticles();
    let index = selectedArticles.findIndex((a) => a.id == articleObject.id);
    if (index !== -1) {
      selectedArticles[index] = articleObject;
      this.parent.setSelectedArticles(selectedArticles);
    }
    this.hide();
  }

  public setArticleDataFromGroup(article) {
    this.getTemplateViewModel().idArticle(article.id);
    this.getTemplateViewModel().image(article.image);
    this.getTemplateViewModel().title(article.title);
    this.getTemplateViewModel().excerpt(article.excerpt);
    this.getTemplateViewModel().permalink(article.permalink);
    this.getTemplateViewModel().imageOverride(article.imageOverride || null);
    this.getTemplateViewModel().titleOverride(article.titleOverride || null);
    this.getTemplateViewModel().excerptOverride(article.excerptOverride || null);
    this.getTemplateViewModel().viewType(article.viewType || 'small');
    this.getTemplateViewModel().label(article.label || 'Related');
  }

}



// WEBPACK FOOTER //
// ./js/components/templates/articlePickerView_template.ts